<button #originRef (click)="guiService.goTo('main/notifications')" [class.active]="dropdownOpen" class="button" mat-icon-button type="button">
  <mat-icon svgIcon="mat:notifications_active"></mat-icon>
</button>
